export default "__VITE_ASSET__7fc13a16__"